module.exports = __webpack_public_path__ + "static/media/iconWrite.89b1d755.svg";